import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';
import { DecaPromoCarriersRequestModalComponent } from '../deca-promo-carriers-request-modal/deca-promo-carriers-request-modal.component';

type IonContentElement = HTMLElement & { getScrollElement?: () => Promise<HTMLElement> };

@Component({
  selector: 'lib-deca-promo-carriers-banner',
  templateUrl: './deca-promo-carriers-banner.component.html',
  styleUrls: ['./deca-promo-carriers-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonButton, TranslateModule],
})
export class DecaPromoCarriersBannerComponent {
  private readonly modalCtrl = inject(ModalController);

  private readonly DASHBOARD_MESSAGES_ELEMENT_ID = 'dashboardMessages';

  public async showRequestPromotionalCreditsModal(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: DecaPromoCarriersRequestModalComponent,
      componentProps: {},
      backdropDismiss: false,
    });

    await modal.present();

    const { role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.scrollToDashboardMessages();
    }
  }

  private scrollToDashboardMessages(): void {
    setTimeout(() => {
      const element = document.getElementById(this.DASHBOARD_MESSAGES_ELEMENT_ID);
      if (!element) {
        return;
      }

      const ionContent = element.closest('ion-content') as IonContentElement | null;

      if (ionContent?.getScrollElement) {
        void ionContent.getScrollElement().then((scrollElement) => {
          const elementTop = element.getBoundingClientRect().top;
          const scrollTop = scrollElement.getBoundingClientRect().top;
          const top = scrollElement.scrollTop + (elementTop - scrollTop);

          scrollElement.scrollTo({ top, behavior: 'smooth' });
        });
        return;
      }

      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  }
}
